import { Box, Button } from "@mui/material";
import { API_URL, BootstrapTooltip } from "../../utilities";
import PageTitle from "../../components/PageTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
  GridRowId,
  GridRowModel,
  GridRowModes,
  GridRowModesModel,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import moment from "jalali-moment";
import GridViewMUIX from "../../components/GridViewMUIX";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/auth";
import { MouseEvent, useEffect, useState } from "react";
import { useNotifications } from "@toolpad/core/useNotifications";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import PopoverComponent from "../../components/PopoverComponent";
import NewBaseDefinition from "./new-base-definition";
import {
  BaseDefinitionType,
  ListOfBaseDefinitionType,
} from "src/interface/enum/BaseDefinitionType ";
import SkeltonProgress from "../../components/SkeltonProgress";
import { ListOfTagsColor } from "src/interface/enum/TagsColor";
const BaseDefinitions = () => {
  const notifications = useNotifications();
  const { user } = useAuth();
  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ["BaseDefinitionData"],
    queryFn: () =>
      fetch(API_URL + "base-definition", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      }).then((res) => res.json()),
  });
  const [rows, setRows] = useState<any>();
  const [openBase, setOpenBase] = useState<boolean>(false);

  useEffect(() => {
    if (error) {
      notifications.show("خطا در دریافت اطلاعات" + error.toString(), {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    }
  }, [error]);

  useEffect(() => {
    data && setRows(data);
  }, [data, user?.token]);
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});

  const columns: GridColDef[] = [
    {
      field: "caption",
      headerName: "عنوان",
      flex: 1,

      align: "left",
      headerAlign: "left",
      disableColumnMenu: true,
      editable: true,
      sortable: false,
    },
    {
      field: "definType",
      minWidth: 180,
      align: "center",
      headerAlign: "center",
      headerName: "نوع",
      editable: true,
      sortable: true,
      type: "singleSelect",
      valueOptions: ListOfBaseDefinitionType,
    },
    {
      field: "other",
      minWidth: 80,
      align: "center",
      headerAlign: "center",
      headerName: "فیلد مرتبط",
      editable: true,
      sortable: true,
      type: "singleSelect",
      valueOptions: ListOfTagsColor,
    },
    {
      field: "isActive",
      headerName: "وضعیت فرم",
      editable: true,
      sortable: true,
      headerAlign: "center",
      align: "center",
      type: "boolean",
    },
    {
      field: "createdOn",
      headerName: "تاریخ ثبت",
      sortable: true,
      headerAlign: "center",
      align: "center",
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
    {
      field: "modifiedOn",
      headerName: "آخرین تغییرات",
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
    {
      field: "actions",
      type: "actions",
      headerAlign: "center",
      headerName: "عملیات",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      cellClassName: "actions",
      minWidth: 100,
      getActions: (params) => {
        const isInEditMode =
          rowModesModel[params.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <BootstrapTooltip title="ذخیره">
              <GridActionsCellItem
                icon={<SaveIcon color="success" />}
                label="Save"
                sx={{
                  color: "primary.main",
                }}
                onClick={handleSaveClick(params.id)}
              />
            </BootstrapTooltip>,
            <BootstrapTooltip title="انصراف">
              <GridActionsCellItem
                icon={<CancelIcon color="error" />}
                label="Cancel"
                className="textPrimary"
                onClick={handleCancelClick(params.id)}
                color="inherit"
              />
            </BootstrapTooltip>,
          ];
        }

        return [
          <BootstrapTooltip title="ویرایش">
            <GridActionsCellItem
              icon={<EditIcon color="primary" />}
              label="ویرایش"
              className="textPrimary"
              onClick={handleEditClick(params.id)}
              color="inherit"
            />
          </BootstrapTooltip>,
          <BootstrapTooltip title="حذف">
            <GridActionsCellItem
              icon={<DeleteIcon color="error" />}
              label="حذف"
              onClick={(event) =>
                handleDeleteClick(event, params.id.toString())
              }
              color="inherit"
            />
          </BootstrapTooltip>,
        ];
      },
    },
  ];

  const { mutateAsync: updateAsync, isPending: isEditLoading } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "base-definition/" + body.id, {
        method: "PUT",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log("eee", error);
    },
  });

  const { mutateAsync: deleteAsync, isPending: isDeleteLoading } = useMutation({
    mutationFn: async () => {
      const response = await fetch(API_URL + "base-definition/" + formId, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });

  const [formId, setFormId] = useState("");

  const [anchorDeleteEl, setAnchorDeleteEl] =
    useState<HTMLButtonElement | null>(null);
  const openDeletePopover = Boolean(anchorDeleteEl);
  const idDeletePopover = openDeletePopover ? "simple-popover" : undefined;
  const handleDeleteClick = (
    event: MouseEvent<HTMLButtonElement>,
    id: string
  ) => {
    setAnchorDeleteEl(event.currentTarget);
    setFormId(id);
  };
  const handleDeletePopoverClose = () => {
    setAnchorDeleteEl(null);
  };
  const handleDelete = async () => {
    try {
      const res = await deleteAsync();
      if (res.status) {
        notifications.show("حذف با موفقیت انجام شد!", {
          severity: "success",
          autoHideDuration: 5000,
        });
      } else {
        notifications.show("خطا در حذف!", {
          severity: "error",
          autoHideDuration: 5000,
        });
      }
    } catch (error) {
      console.log("🚀 ~ handleDelete ~ error:", error);
      notifications.show("خطا در حذف!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    } finally {
      refetch();
      handleDeletePopoverClose();
    }
  };

  function EditToolbar() {
    return (
      <GridToolbarContainer>
        <Button
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setOpenBase(true)}
        >
          آیتم جدید
        </Button>
      </GridToolbarContainer>
    );
  }
  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const processRowUpdate = async (newRow: GridRowModel) => {
    const updatedRow = { ...newRow, isNew: false };
    const res = await updateAsync(updatedRow);
    if (res.status) {
      refetch();
      setRows(
        rows.map((row: any) => (row.id === newRow.id ? updatedRow : row))
      );
      notifications.show("تغییرات اعمال شد!", {
        severity: "success",
        autoHideDuration: 5000,
      });
    } else {
      notifications.show("مشکل در ذخیره ساز!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    }
    return updatedRow;
  };

  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row: any) => row.id === id);
    if (editedRow!.isNew) {
      setRows(rows.filter((row: any) => row.id !== id));
    }
  };
  const handleClose = () => {
    setOpenBase(false);
  };
  return (
    <>
      <PageTitle title="تعاریف پایه" />
      <PopoverComponent
        caption=" حذف انجام شود؟"
        anchorEl={anchorDeleteEl}
        handlePopoverClose={handleDeletePopoverClose}
        handler={handleDelete}
        id={idDeletePopover}
        isLoading={isDeleteLoading}
        open={openDeletePopover}
        key={"delete"}
      />

      <NewBaseDefinition
        open={openBase}
        handleClose={handleClose}
        refetch={refetch}
        // data={rowInfo}
      />

      <Box
        sx={{
          width: {
            xs: 370, // عرض برای اندازه‌های کوچک
            sm: 500, // عرض برای اندازه‌های متوسط
            md: 720, // عرض برای اندازه‌های بزرگ
            lg: "calc(100% - 80px)", // عرض برای اندازه‌های خیلی بزرگ
            xl: "calc(100% - 80px)", // عرض برای اندازه‌های فوق‌العاده بزرگ
          },
        }}
      >
        {isLoading ? (
          <SkeltonProgress />
        ) : (
          <GridViewMUIX
            columns={columns}
            loading={isLoading}
            EditToolbar={EditToolbar}
            rowModesModel={rowModesModel}
            processRowUpdate={processRowUpdate}
            rows={rows}
            sortFields={{ field: "modifiedOn", sort: "desc" }}
            setRowModesModel={setRowModesModel}
            gridUniqueName="BaseDefinitions"
          />
        )}
      </Box>
    </>
  );
};

export default BaseDefinitions;
